import { LessorOnboardingDraft } from '~modules/onboarding/types';

import { ApiLease, ApiProperty, ApiUserMeta } from '~shared/types';

export const ONBOARDING_STEP_QUERY_PARAM = 'step';
export const ONBOARDING_WELCOME_STEP = 'welcome';

type LessorOnboardingEligibilityParams = {
  properties?: ApiProperty[];
  leases?: ApiLease[];
  meta?: ApiUserMeta;
};

export const shouldStartLessorOnboarding = ({
  properties,
  leases,
  meta,
}: LessorOnboardingEligibilityParams) =>
  properties?.length === 0 &&
  leases?.length === 0 &&
  !meta?.lessor.onboarding_completed_at;

export const shouldRedirectToLessorOnboarding = ({
  draft,
  ...params
}: LessorOnboardingEligibilityParams & {
  draft?: LessorOnboardingDraft | null;
}) => !draft && shouldStartLessorOnboarding(params);

export const canRestartLessorOnboarding = ({
  properties,
  leases,
  meta,
}: LessorOnboardingEligibilityParams) =>
  properties?.length === 0 &&
  leases?.length === 0 &&
  !meta?.lessor.onboarding_completed_at;

export const shouldShowLessorOnboardingWelcome = ({
  draft,
  meta,
  requestedStep,
}: {
  draft?: LessorOnboardingDraft | null;
  meta?: ApiUserMeta;
  requestedStep?: string | null;
}) =>
  requestedStep === ONBOARDING_WELCOME_STEP &&
  Boolean(meta) &&
  !draft &&
  !meta?.lessor.onboarding_started_at &&
  !meta?.lessor.onboarding_completed_at;
